<template>
  <div class="fixed top-4 right-4 z-50 w-96 max-w-full pointer-events-none">
    <div class="space-y-2 pointer-events-auto">
      <NotificationItem
        v-for="notification in notificationStore.notifications"
        :key="notification.id"
        :notification="notification"
        @close="notificationStore.remove"
      />
    </div>
  </div>
</template>

<script setup>
import { useNotificationStore } from '../stores/notification.js'
import NotificationItem from './NotificationItem.vue'

const notificationStore = useNotificationStore()
</script>

<style scoped>
/* 確保通知容器在最上層 */
.z-50 {
  z-index: 50;
}
</style>